import { render, staticRenderFns } from "./OutlinedButton.vue?vue&type=template&id=24dc7a30&"
import script from "./OutlinedButton.vue?vue&type=script&lang=js&"
export * from "./OutlinedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports